<!--suppress JSUnresolvedVariable -->
<template>
  <div v-if="componentKey > 0" class="chart-wrapp" style="max-width: 100%;">
    <div class="weather-graph-start">
      <highcharts :key="componentKey" :options="chartOptions" :constructor-type="'stockChart'"></highcharts>
    </div>
  </div>
</template>

<script>
import { Chart } from 'highcharts-vue'
import stockInit from 'highcharts/modules/stock'
import Highcharts from 'highcharts'
import 'flatpickr/dist/themes/dark.css'
import '@/assets/css/js-datapicer.scss'
import graphConfigs from '@/components/graphConfigs'
import moment from 'moment'
import data from '@/api/data'

stockInit(Highcharts)

export default {
  name: 'ProductionAndInsolation',
  mixins: [graphConfigs],
  components: {
    'highcharts': Chart
  },
  data() {
    return {
      unsubscribe: null,
      hasIsolation: null,
      componentKey: 0,
      dateTime: null,
      loading: false,
      dateError: '',
      chartOptions: {
        chart: {
          marginLeft: 100,
          type: 'column'
        },
        time: {
          useUTC: false,
        },
        series: [
          {
            data: [],
            name: 'Production'
          }
        ],
        xAxis: {
          labels: {
            style: {
              color: '#fff'
            }
          }
        },
        rangeSelector: {
          inputEnabled: false,
          buttons: [
            {
              type: 'all',
              //              count: 1,
              text: 'Сутки',
              dataGrouping: {
                forced: true,
                units: [
                  [
                    'day',
                    [1]
                  ]
                ]
              }
            },
            {
              type: 'day',
              count: 1,
              text: 'Почасово',
              dataGrouping: {
                forced: true,
                units: [
                  [
                    'hour',
                    [1]
                  ]
                ]
              }
            }
          ],
          buttonTheme: {
            fill: '#333333',
            stroke: '#333333',
            width: 90,
            height: 17,
            style: {
              color: '#ffffff',
              fontSize: '14px'
            },
            states: {
              hover: {
                fill: '#242526',
                stroke: '#242526'
              },
              select: {
                fill: '#f36f37',
                stroke: '#f36f37'
              }
            }
          }
        },
        yAxis: [{
          gridLineColor: '#4f5051',
          labels: {
            format: '{value} KWh',
            style: {
              color: '#FFFFFF'
            }
          },
          title: {
            text: 'Production',
            style: {
              color: '#FFFFFF'
            }
          },
          opposite: true
        }]
      }
    }
  },
  mounted() {
    this.hasIsolation = this.$store.getters['station/station'].schema.insolationSensor !== null

    if (this.hasIsolation) {
      this.chartOptions.yAxis.push({
        gridLineWidth: 0,
        title: {
          text: 'Insolation',
          style: {
            color: '#FFFFFF'
          }
        },
        labels: {
          format: '{value} Wh/m^2',
          style: {
            color: '#FFFFFF'
          }
        },
        opposite: false
      })
    }

    this.unsubscribe = this.$store.subscribe(mutation => {
      if (mutation.type === 'production/FETCH_PRODUCTION') {
        this.fetchData(mutation.payload.dateFrom, mutation.payload.dateTo)
      }
      if (mutation.type === 'production/COMPARE_PRODUCTION') {
        let firstRange = []
        let secondRange = []

        this.$store.getters['production/productionMap'].forEach((value, key) => {
          const date = moment(key)

          if (date.isBetween(mutation.payload.firstDateFrom, mutation.payload.firstDateTo, undefined, '[]')) {
            firstRange.push({
              x: date.valueOf(),
              y: value,
              date: date.format('DD.MM.YYYY')
            })
          }

          if (date.isBetween(mutation.payload.secondDateFrom, mutation.payload.secondDateTo, undefined, '[]')) {
            secondRange.push({
              x: date.valueOf(),
              y: value,
              date: date.format('DD.MM.YYYY')
            })
          }
        })

        console.log(firstRange, secondRange)

        if (firstRange.length !== secondRange.length) {
          if (firstRange.length < secondRange.length) {
            const a = firstRange
            firstRange = secondRange
            secondRange = a
          }

          firstRange.forEach((elem, index) => {
            if (secondRange[index] !== undefined) {
              secondRange[index] = {
                x: firstRange[index].x,
                y: secondRange[index].y,
                date: secondRange[index].date
              }
            } else {
              secondRange[index] = {
                x: firstRange[index].x,
                y: null,
                date: null
              }
            }
          })
        }

        if (firstRange.length < secondRange.length) {
          this.chartOptions.series = [
            {
              data: firstRange,
              name: 'First period'
            },
            {
              data: secondRange,
              name: 'Second period'
            }
          ]
        } else {
          this.chartOptions.series = [
            {
              data: secondRange,
              name: 'First period'
            },
            {
              data: firstRange,
              name: 'Second period'
            }
          ]
        }

        this.forceRerender()
      }
    })

    this.fetchData(this.$store.getters['production/fetchDates'].dateFrom, this.$store.getters['production/fetchDates'].dateTo)
  },
  beforeDestroy() {
    this.unsubscribe()
  },
  methods: {
    forceRerender() {
      this.componentKey += 1
    },
    fetchData(dateFrom, dateTo) {
      data.productionAndInsolationByHour(this.$route.params.id, {
        from: dateFrom,
        to: dateTo
      }).then(r => {
        const production = []
        const insolation = []

        r.data.forEach(val => {
          const time = moment(val.time)

          production.push([time.valueOf(), val.production])

          if (this.hasIsolation) {
            insolation.push([time.valueOf(), val.insolation])
          }
        })

        const series = [
          {
            data: production,
            name: 'Production'
          }
        ]
        if (this.hasIsolation) {
          series.push({
            data: insolation,
            name: 'Insolation',
            yAxis: 1,
            color: '#f78d2c'
          })
        }

        this.chartOptions.series = series
        this.forceRerender()
      })
    }
  }
}
</script>
